import { KYMW1307Model } from '../kymw1307.model';
import { KYMW1307GetSummaryTableModel } from '../vo/kymw1307-get-summary-table.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 予算・計画・実績画面　予算・計画・実績表を取得するサービス
 *
 * @export GetSummaryTableService
 * @class GetSummaryTableService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetSummaryTableService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1307Model}
   * @memberof GetSummaryTableService
   */
  private model: KYMW1307Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {KYMW1307GetSummaryTableModel}
   * @memberof GetSummaryTableService
   */
  private vo: KYMW1307GetSummaryTableModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetSummaryTableService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSummaryTableService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        DisplayMode: this.vo.displayMode,
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        SellAreaCode: this.vo.sellAreaCode,
        OrderNumQuotaCode: this.vo.orderNumQuotaCode,
        CoopCode: this.vo.coopCode,
        ClassCode: this.vo.classCode,
        MiddleClassCode: this.vo.middleClassCode,
        SmallClassCode: this.vo.smallClassCode,
        PageNum: this.vo.pageNum,
        BuyerCode: this.vo.buyerCode,
        NonCarryFlag: this.vo.nonCarryFlag,
        OrdrClientCode: this.vo.orderClientCode,
        OrdrClientKanji: this.vo.orderClientKanji,
        PayeeClientCode: this.vo.payeeClientCode,
        PayeeClientKanji: this.vo.payeeClientKanji  
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetSummaryTableService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW1307Model>model;
    this.vo = <KYMW1307GetSummaryTableModel>vo;
    this.successFunc = successFunc;
    this.send('getSummaryTable', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSummaryTableService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
